import req from "@/assets/js/axios"

export default {
    // 获取设计学院列表 
    getFrontColleges: (params) => {
        return req.apiAxios('POST', '/college/CollegeController/getFrontColleges', params)
    },
    // 发表评论
    createFrontEvaluate: (params) => {
        return req.apiAxios('POST', '/host/evaluate/EvaluateController/starrycastle-security/createFrontEvaluate', params)
    },
    // 评论列表
    getFrontEvaluates: (params) => {
        return req.apiAxios('POST', '/host/evaluate/EvaluateController/getFrontEvaluates', params)
    },
    // 相关推荐
    schoolRecommend: (params) => {
        return req.apiAxios('POST', '/college/CollegeController/getRecommend', params)
    },
    // 报名
    schoolApply: (params) => {
        return req.apiAxios('POST', '/host/apply/ApplyController/starry-security/createApply', params)
    },
    // 查询报名
    getApplyCollege:(params) => {
        return req.apiAxios('POST', '/business/college/BCollegeController/whale-security/getApplyCollege', params)
    },
    // 删除报名
    deleteApply:(params) => {
        return req.apiAxios('POST', '/host/business/apply/ApplyController/deleteApply', params)
    }
}
